"use client";

import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

type OtpInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

const OtpInput = ({ className, ...props }: OtpInputProps) => (
  <input
    type="text"
    inputMode="numeric"
    pattern="[0-9]*"
    maxLength={6}
    autoComplete="one-time-code"
    className={cn(
      "h-[46px] w-full rounded-full bg-sand-10 border border-sand-10 px-6 py-4 text-lg text-black caret-sky-50 text-center placeholder:text-gray-75 focus:outline-none focus:ring-2 focus:ring-sky-50 md:text-xl",
      className
    )}
    {...props}
  />
);

export { OtpInput };
